var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 48.25C23.25 47.2554 23.6451 46.3016 24.3483 45.5983C25.0516 44.8951 26.0054 44.5 27 44.5H37C37.9946 44.5 38.9484 44.8951 39.6517 45.5983C40.3549 46.3016 40.75 47.2554 40.75 48.25",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 38.25V48.25",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 32H18.25C18.25 33.6576 18.9085 35.2473 20.0806 36.4194C21.2527 37.5915 22.8424 38.25 24.5 38.25H39.5C41.1576 38.25 42.7473 37.5915 43.9194 36.4194C45.0915 35.2473 45.75 33.6576 45.75 32H49.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6438 15.75C26.3428 15.75 26.052 15.8586 25.8247 16.0557C25.5973 16.2529 25.4488 16.5255 25.4063 16.8234L23.2625 31.8234C23.2372 32.0007 23.2503 32.1814 23.3009 32.3531C23.3515 32.5249 23.4384 32.6838 23.5558 32.8191C23.6731 32.9544 23.8181 33.0628 23.9811 33.1372C24.144 33.2115 24.321 33.25 24.5 33.25H39.5C39.6791 33.25 39.8561 33.2115 40.019 33.1372C40.1819 33.0628 40.327 32.9544 40.4443 32.8191C40.5616 32.6838 40.6486 32.5249 40.6991 32.3531C40.7497 32.1814 40.7628 32.0007 40.7375 31.8234L38.5938 16.8234C38.5513 16.5255 38.4027 16.2529 38.1754 16.0557C37.9481 15.8586 37.6572 15.75 37.3563 15.75H26.6438Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.8d1540e873ff574eba779f127948f28e.svg";
export { ForwardRef as ReactComponent };